import React, {useEffect, useState} from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import {observer} from 'mobx-react-lite'
import appStore from "../storage/AppStore";

// Custom icon to avoid default marker issue
const customIcon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

const ClickableMap = ({center, zoom, store, prop}) => {
  const [valid, setValid] = useState(true);
  useEffect(() => {
    if (store.was_validated && !store[prop]) {
      setValid(false);
    } else {
      setValid(true);
    }

  }, [store.was_validated, store[prop]]);

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        store.setProperty(prop, e.latlng)
      }
    });
    return null;
  };

  return (
      <>
        {!valid && <div className={"alert alert-danger"}>{appStore.tr.select_point_on_map}</div>}
        <MapContainer center={center} zoom={zoom || 13} style={{height: "400px", width: "100%"}}>
          <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MapClickHandler/>
          {store[prop] && <Marker position={store[prop]} icon={customIcon}/>}
        </MapContainer>
      </>
  );
}

export default observer(ClickableMap);
